// extracted by mini-css-extract-plugin
export default {"cookiebar":"cookiebar__xrRDK","shown":"shown__KDAei"};